module.exports = __webpack_public_path__ + "img/Palestine.6c64dc88.gif";